import { Button, ButtonGroup } from "@mui/material";
import i18n from "i18n/i18n";
import { useState } from "react";
import { useBoundStore } from "store/store";

function BadgeTabs(props: any) {
  const lang = useBoundStore((state) => state.lang);
  return (
    <div className="_buttonGroup">
      <ButtonGroup
        variant="outlined"
        aria-label="Basic button group"
        sx={{ height: "36px" }}
      >
        {props.content.map((item: any, index: number) => {
          return (
            <Button
              sx={{ width: "max-content", cursor : item.disabled ? "not-allowed" : "pointer" }}
              startIcon={
                (props.activeId === item.id || item.disabled)? item.activeIcon : item.inActiveIcon
              }
              onClick={() => {
                
                props.setActiveId(item.id);
              }}
              variant={ props.activeId === item.id ? "contained" : "outlined"}
              disabled={item.disabled}
            >
              {item.text}
            </Button>
          );
        })}
      </ButtonGroup>

     {props.showDesc ? <div className="secondaryTitleNormal" style={{ margin: "24px 0px" }}>
        {props.activeId === 0 ? i18n(lang).time_based_report_description : props.activeId === 1 ? i18n(lang).flash_based_report_description : i18n(lang).event_based_report_description}
      </div> : "" }
    </div>
  );
}

export default BadgeTabs;
